export * from './baChartistChart.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baChartistChart/index.ts